export const adminTodayRemindersTarget = '/admin/reminders?view=today'

export function normalizeNotificationTarget(rawTarget: string | undefined | null, origin: string): string | null {
  if (!rawTarget) return null
  try {
    // URL() normalizes malformed percent escapes instead of rejecting them.
    decodeURI(rawTarget)
    const target = new URL(rawTarget, origin)
    const allowedOrigin = new URL(origin).origin
    if (target.origin !== allowedOrigin || (target.protocol !== 'http:' && target.protocol !== 'https:')) return null
    return `${target.pathname}${target.search}${target.hash}`
  } catch {
    return null
  }
}
